(() => {
  const init = async () => {
    const nodes = document.querySelectorAll('[data-kbd-product-update]:not([data-kbd-initialized])');
    await Promise.all(Array.from(nodes).map(async (node) => {
      node.dataset.kbdInitialized = 'true';
      try {
        const response = await fetch(`/apps/kbd-notify/product-updates?productId=${encodeURIComponent(node.dataset.productId)}`, { headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok || !data.enabled) return;
        const status = data.status || '';
        const estimatedDate = data.estimatedDate || 'TBD';
        const title = data.titleEn || data.title || 'Project update';
        const summary = data.summaryEn || data.latest?.bodyEn || data.latest?.titleEn || '';
        node.querySelector('[data-kbd-update-eyebrow]').textContent = `${data.category} · ${status} · ETA ${estimatedDate}`;
        node.querySelector('[data-kbd-update-percent]').textContent = `${data.progress}%`;
        node.querySelector('[data-kbd-update-title]').textContent = title;
        node.querySelector('[data-kbd-update-bar]').style.width = `${data.progress}%`;
        node.querySelector('[data-kbd-update-summary]').textContent = summary;
        node.hidden = false;
      } catch { node.hidden = true; }
    }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
